/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright © 2026 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
* patent applications, and are protected by trade secret or copyright law.
* Dissemination of this information, reproduction of this material, and copying or distribution of this software
* is strictly forbidden unless prior written permission is obtained
* from Pearson Education, Inc.
*/

/**
 * Root provider: Harness FME (OpenFeature + Split) unless integrated MLM launch omits it.
 *
 * @file initializeHarnessOpenFeature.js
 * @author Mohamed yasar arabath M
 */

import { OpenFeature } from '@openfeature/web-sdk';
import { SplitFactory } from '@splitsoftware/splitio-browserjs';
import { OpenFeatureSplitProvider } from '@splitsoftware/openfeature-web-split-provider';
import env from '../env';

export default async function initializeHarnessOpenFeature() {
  const splitFactory = SplitFactory({
    core: {
      authorizationKey: env.HARNESS_FME_BROWSER_SDK_KEY,
      key: env.HARNESS_FME_ANONYMOUS_TARGETING_KEY
    },
    streamingEnabled: false
  });
  const provider = new OpenFeatureSplitProvider(splitFactory);
  const initialContext = {
    targetingKey: env.HARNESS_FME_ANONYMOUS_TARGETING_KEY,
    trafficType: 'user'
  };
  await OpenFeature.setProviderAndWait(provider, initialContext);
}
